import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';

import { AuthenticationService } from '../../authentication/authentication.service';
import { NavService } from '../../services/nav.service';

declare const UIkit: any;

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit, OnDestroy {
  navOpen: boolean;
  navOpenSubscription: Subscription;
  username: string;

  constructor(
    private authenticationService: AuthenticationService,
    private cookieService: CookieService,
    private location: Location,
    private navService: NavService
  ) {}

  ngOnInit(): void {
    this.username = this.cookieService.get('username');
    this.navOpenSubscription = this.navService.navOpen.subscribe((value: boolean) => (this.navOpen = value));
    const main = document.querySelector('.main');

    UIkit.util.on('#offcanvas', 'beforeshow', this.showNav.bind(this, main));

    UIkit.util.on('#offcanvas', 'beforehide', this.hideNav.bind(this, main));

    UIkit.offcanvas('#offcanvas').show();
  }

  hideNav(element: Element): void {
    element.classList.add('smooth-hide');
    this.navService.navOpen.next(false);
    setTimeout(() => {
      element.classList.remove('uk-offcanvas-container', 'uk-offcanvas-container-animation');
    }, 300);
  }

  logout(): void {
    this.authenticationService.revokeToken().subscribe(() => {
      this.authenticationService.removeCookies();
      this.location.go('');
      this.authenticationService.redirectUrl = '';
    });
  }

  showNav(element: Element): void {
    element.classList.remove('smooth-hide');
    this.navService.navOpen.next(true);
    setTimeout(() => {
      document.body.classList.remove('uk-offcanvas-container', 'uk-offcanvas-container-animation');
      element.classList.add('uk-offcanvas-container', 'uk-offcanvas-container-animation');
    }, 300);
  }

  ngOnDestroy(): void {
    this.navOpenSubscription.unsubscribe();
  }
}
